module.exports = __webpack_public_path__ + "media/images/desc-icon-1014989c3c000ce4bd2814c6d51e93d1.png";